import { memo, useEffect, useRef } from "react";

import { IconButton, Row } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import cc from "classcat";

import styles from "../SearchBar.module.scss";
import { useSearchBar } from "../context";

import { SearchBarIcon } from "./SearchBar.Misc";
import SearchBarChips from "./SearchBar.FilterChips";
import SearchBarResults from "./SearchBarResults/SearchBarResults";

const SearchBarExpanded = () => {
  const { l10n } = useLocalization();
  const {
    isOpen,
    paneRef,
    searchTerm,
    searchTermChangeHandler,
    setResultsFilter,
    setClosed,
  } = useSearchBar();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    } else {
      searchTermChangeHandler("");
      setResultsFilter("all");
    }
  }, [isOpen, searchTermChangeHandler, setResultsFilter]);

  return (
    <div
      ref={paneRef}
      className={cc([
        styles["search-pane"],
        isOpen && styles["search-pane--open"],
      ])}
    >
      <Row className={styles["search-pane-bar"]} alignItems="center">
        <SearchBarIcon />
        <Row.Item>
          <input
            ref={inputRef}
            type="search"
            className={styles["search-input"]}
            aria-label={l10n.getString("search-bar-collapsed-placeholder")}
            value={searchTerm}
            onChange={(x) => searchTermChangeHandler(x.target.value)}
          />
        </Row.Item>
        <IconButton name="x" textSize="l" onClick={setClosed} />
      </Row>
      <SearchBarChips />
      <SearchBarResults />
    </div>
  );
};

export default memo(SearchBarExpanded);
